// matchMedia can be missing (old browsers) or, under CRA's resetMocks in tests, return undefined:
// every motion check reads it defensively and treats "unknown" as "motion allowed".
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return Boolean(window.matchMedia('(prefers-reduced-motion: reduce)')?.matches);
}

export function hasFinePointer(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return Boolean(window.matchMedia('(pointer: fine)')?.matches);
}

// A click the browser should handle itself: modified (new tab/window) or not the main button.
export function isPlainClick(e: { button: number; metaKey: boolean; ctrlKey: boolean; shiftKey: boolean; altKey: boolean }): boolean {
  return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
}
